"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PType = void 0;
/**
 * @abstract
 */
var PType = /** @class */ (function () {
    function PType() {
        /**
         * probably never used;
         *
         * here only to make a difference from any generic object
        */
        this._isPType = true;
    }
    return PType;
}());
exports.PType = PType;
;
